module.exports = __webpack_public_path__ + "assets/-_4.c2a98b2a.svg";